export default __webpack_public_path__ + "static/media/martini.7e201fc4.svg";